export default "__VITE_ASSET__CtQHYVCC__"